export const brands = {
  APRILYOS: {
    key: "APRILYOS",
    name: "Aprilyos",
    colors: {
      primary: "#07153C",
      primaryHover: "#6D84C4",
      secondary: "#9E0430",
      secondaryHover: "#F21B3F",
      white: "#FFFFFF",
      backgroundGrey: "#F3F3F3",
      grey: "#CCCCCC",
      green: "#317B22",
      greenHover: "#215217",
      red: "#9E0430",
      redHover: "#F21B3F",
      redDark: "#720524",
      blue: "#394874",
      blueHover: "#6D84C4",
      blueLight: "#B0BFE8",
      cobalt: "#394874",
      bleuet: "#6D84C4",
      dragee: "#EAEDF4",
      klein: "#14248A",
      cyan: "#009DFF",
      givre: "#06C9B3",
      lime: "#C2E812",
      orange: "#FF9D00",
      pink: "#FF21FF",
      blueFinance: "#93A8E5",
      text: "#07153C",
      textSecondary: "#A5ABB2",
      textTertiary: "#6D84C4",
      avpColor:"#317B22",
      avpColorHover:"#6FA364",
      exeColor:"#6D84C4",
      exeColorHover:"#B0BFE8"
    },
    favicon: "/static/favicon.ico",
    title: "Aprilyos",
    mailContact: "commercial@aprilyos.com",
    features: {
      tutorials: true,
      partenaires : true,
      signup: true,
      copyright: true
    }
  },

  LNI: {
    key: "LNI",
    name: "LNI Groupe",
    colors: {
      primary: "#009688",
      primaryHover: "#4AB7A2",
      secondary: "#4AB7A2",
      secondaryHover: "#52c9b3",
      white: "#FFFFFF",
      backgroundGrey: "#F9F9F9",
      grey: "#BCBCBC",
      green: "#009688",
      greenHover: "#4AB7A2",
      red: "#F04237",
      redHover: "#FF5A4F",
      redDark: "#C73127",
      blue: "#1C40AD",
      blueHover: "#5089FE",
      blueLight: "#8CC4D7",
      cobalt: "#1C40AD",
      bleuet: "#5089FE",
      dragee: "#D9D8CC",
      greenAlt: "#4BB6A2",
      greyAlt: "#8E908E",
      klein: "#536F7F",
      cyan: "#55AFA3",
      givre: "#8CC4D7",
      lime: "#FEE335",
      orange: "#B19227",
      pink: "#F04237",
      blueFinance: "#536F7F",
      text: "#1D1D1B",
      textSecondary: "#555555",
      textTertiary: "#4AB7A2",
      avpColor:"#1D1D1B",
      exeColor:"#4AB7A2",
      avpColorHover: "#555555",
      exeColorHover: "#52c9b3",

    },
    favicon: "/static/lni-favicon.jpeg",
    title: "Logiciel LNI",
    mailContact: "logiciel@lni.com",
    features: {
      tutorials: false,
      partenaires : false,
      signup: false,
      copyright: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/brand.js